<template>
  <section v-if="groups && groups.length" class="field-glossary">
    <div class="glossary-header">
      <div>
        <h3 class="glossary-title">{{ title }}</h3>
        <p v-if="description" class="glossary-description">{{ description }}</p>
      </div>
    </div>
    <div class="glossary-groups" :class="columnClass">
      <div
        v-for="(column, columnIndex) in normalizedColumns"
        :key="`column-${columnIndex}`"
        class="glossary-column"
      >
        <article
          v-for="(group, groupIndex) in column"
          :key="`${group.title || 'group'}-${columnIndex}-${groupIndex}`"
          class="glossary-group"
        >
          <h4 v-if="group.title" class="group-title">{{ group.title }}</h4>
          <dl class="glossary-list">
            <template v-for="(item, itemIndex) in group.items">
              <dt :key="`term-${columnIndex}-${groupIndex}-${itemIndex}`" class="glossary-term">{{ item.term }}</dt>
              <dd :key="`desc-${columnIndex}-${groupIndex}-${itemIndex}`" class="glossary-definition">{{ item.description }}</dd>
            </template>
          </dl>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FieldGlossary',
  props: {
    title: {
      type: String,
      default: 'Glossary'
    },
    description: {
      type: String,
      default: ''
    },
    groups: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Number,
      default: 2
    }
  },
  computed: {
    columnClass() {
      return this.columns === 3 ? 'columns-3' : 'columns-2'
    },
    normalizedColumns() {
      if (!this.groups.length) return []
      if (Array.isArray(this.groups[0])) return this.groups
      return this.groups.map(group => [group])
    }
  }
}
</script>

<style lang="less" scoped>
.field-glossary {
  padding: 18px 20px;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  background: #f9fafb;
}

.glossary-header {
  margin-bottom: 14px;
}

.glossary-title {
  margin: 0;
  color: #374151;
  font-size: 17px;
  line-height: 1.3;
  font-weight: 600;
}

.glossary-description {
  margin: 6px 0 0;
  color: #9ca3af;
  font-size: 13px;
  line-height: 1.6;
}

.glossary-groups {
  display: grid;
  gap: 14px;
}

.glossary-groups.columns-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.glossary-groups.columns-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.glossary-column {
  min-width: 0;
}

.glossary-group {
  min-width: 0;
}

.glossary-group + .glossary-group {
  margin-top: 16px;
}

.group-title {
  margin: 0 0 10px;
  color: #dc2626;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 600;
}

.glossary-list {
  margin: 0;
  display: grid;
  grid-template-columns: minmax(110px, 0.9fr) minmax(0, 2fr);
  column-gap: 16px;
  row-gap: 4px;
}

.glossary-term {
  color: #4b5563;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 600;
  margin: 0;
}

.glossary-definition {
  margin: 0;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.35;
}

@media (max-width: 900px) {
  .glossary-groups.columns-2,
  .glossary-groups.columns-3 {
    grid-template-columns: 1fr;
  }

  .glossary-list {
    grid-template-columns: 1fr;
    row-gap: 2px;
  }

  .glossary-definition {
    margin-bottom: 8px;
  }
}
</style>
